
export const VERSION = '5.4.39'; // Update this manually on each release


